<template>
  <div class="container">
    <div class="head">
      <img src="@/assets/back.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
      <div>注册</div>
      <div style="margin-right: 10px;color: #FE003B" @click="login">登录</div>
    </div>

    <van-form>
      <van-field
        style="margin-top: 100px"
        name="手机号码"
        label="+86"
        placeholder="请获取手机号码"
        :rules="[{ required: true, message: '请获取手机号码' }]"
      >
      </van-field>

      <van-field
        style="margin-top: 26px"
        name="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <van-button class="panel" size="small" type="default">获取验证码</van-button>
        </template>
      </van-field>


      <div class="xieyi">《用户注册条款协议》</div>

    </van-form>

    <van-radio-group v-model="radio" direction="horizontal" style="margin-top: 37px;margin-left: 12px">
      <van-radio name="1" checked-color="red">原厂</van-radio>
      <van-radio name="2" checked-color="red" style="margin-left: 10%">代理商</van-radio>
      <van-radio name="3" checked-color="red" style="margin-left: 10%">高级VIP创客商</van-radio>
    </van-radio-group>

    <div class="register">注册</div>
  </div>
</template>

<script>
  export default {
    name: "register",
    data(){
      return{
        show: false,
        radio:2,
      }
    },
    methods:{
      login(){
        this.$router.push({
          path:'/business/login'
        })
      },
      go(){
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="less" scoped>
  .container{
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .xieyi{
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      color:rgba(93,98,130,1);
      opacity:1;
      margin-left: 12px;
      margin-top: 18px;
    }
    .panel{
      width:88px;
      height:30px;
      background:rgba(7,193,96,1);
      border:1px solid rgba(7,193,96,1);
      opacity:1;
      border-radius:2px;
      color: #ffffff;
    }
    .register{
      width: 95%;
      margin-left: 2%;
      height:40px;
      background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
      border-radius:4px;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:40px;
      color:rgba(255,255,255,1);
      text-align: center;
      opacity:1;
      margin-top: 23px;
      margin-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/login/register.vue